import React from 'react';
import useDocumentTitle from '../../components/useDocumentTitle';
import HomeHero from '../../components/hero/HomeHero';
import Call2action from '../../components/Sections/Call2action';
import HomeCollection from '../../components/collection/HomeCollection';
import HomeNFT from '../../components/cards/HomeNFTs';

const Home = () => {
  useDocumentTitle('Home');
  return (
    <div>
      <HomeHero />
      <HomeNFT length={8} />
      <HomeCollection />
      <Call2action />
    </div>
  );
};

export default Home;